module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/barcode.04ff7808.svg";